import { dasherize, hideTag, showTag } from '../utils';

export default class Panel {
  constructor(groupTag, parent, index) {
    this.tag = groupTag;
    this.element = this.tag.element;
    this.tags = this.tag.subtags;
    this.offset = this.tag.offset;
    this.index = index;
    this.parent = parent;
    this.isRendered = false;
  }

  static get className() {
    return dasherize(this.name);
  }

  get panelName() {
    return this.constructor.className.replace(/-panel$/, '');
  }

  /**
   * a flat list of all tags, associated with their DOM elements
   */
  get allTags() {
    if (this._allTags) {
      return this._allTags;
    }

    const flattenTags = (nestedTags = []) => {
      return nestedTags.reduce((flattened, tag) => {
        const { subtags } = tag;
        return [...flattened, tag, ...flattenTags(subtags)];
      }, []);
    };

    const tags = (this._allTags = flattenTags(this.tags));
    return tags;
  }

  // code that should be run once, the first time the panel is shown
  render() {
    // abstract, implemented by subclasses
  }

  // runs every time we transition to the panel
  activate() {
    // abstract, implemented by subclasses
  }

  // run when switching away from panel, clean up here
  deactivate() {
    // abstract, implemented by subclasses
  }

  getTag(className) {
    return this.allTags.find(t => t.classNames.match(className));
  }

  getTagByTool(toolName) {
    return this.allTags.find(t => t.toolName === toolName);
  }

  hide() {
    hideTag(this.tag);
  }

  show() {
    showTag(this.tag);
  }
}
